import { getPacks } from '../peijian/all'

export default {
  name: 'igs-20',
  // 图文
  imageText: [
    // 模板1
    {
      type: 'formwork1',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-20/chanpingaisu/IGS20-cpgs1.jpg',
      text1: 'Indoor Hydroponics Growing System',
      text2: 'IGS-20',
    },
    {
      type: 'formwork9',
      list: [
        {
          id: 'a-1',
          text: '1、Powerful grow lights, talllamp arm, highwater capacity, large grow deck, and detachable trellis',
        },
        { id: 'a-2', text: '2、Grow up to 12 plants, 5x faster than soil' },
        { id: 'a-3', text: '3、24W LED grow light for patent spectrum,optimallighting' },
        {
          id: 'a-4',
          text: '4、Adjusts for up to 23" of grow height soyou can grow big plants and features alarger bowl to hold more water than the base Harvest',
        },
        { id: 'a-5', text: '5、Touch-sensitive illuminated controlpanel & care indicators' },
        { id: 'a-6', text: '6、Easy, automatic reminders for water &plant food' },
      ],
    },
    // 配件
    {
      type: 'formwork5',
      packs: getPacks([
        { id: 'accessories-1', num: 12 },
        { id: 'accessories-2', num: 12},
        { id: 'accessories-3', num: 12},
        { id: 'accessories-4', num: 12},
        { id: 'accessories-11', num: 1 },
        { id: 'accessories-12', num: 1 },
        { id: 'accessories-17', num: 1 },
      ]),
    },
    // 模板2
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-20/chanpingaisu/IGS20-cpgs2.jpeg',
    },
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-20/chanpingaisu/IGS20-cpgs3.jpg',
    },
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-20/chanpingaisu/IGS20-cpgs4.jpg',
    },
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-20/chanpingaisu/IGS20-cpgs5.jpg',
    },
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-20/chanpingaisu/IGS20-cpgs6.jpg',
    },
    {
      type: 'formwork2',
      img: 'http://igstech.com.cn/resources/shuipei/product-igs-20/chanpingaisu/IGS20-cpgs7.jpg',
    },
  ],
}
